import { graphql } from '~publish/graphql'

export const DELETE_CUSTOM_LINK = graphql(`
  mutation DeleteShopGridCustomLink($input: DeleteShopGridCustomLinkInput!) {
    deleteShopGridCustomLink(input: $input) {
      ... on ShopGridCustomLinksPayload {
        links {
          id
          url
        }
      }
    }
  }
`)

export const ADD_NEW_CUSTOM_LINK = graphql(`
  mutation AddNewShopGridCustomLink($input: AddShopGridCustomLinkInput!) {
    addShopGridCustomLink(input: $input) {
      ... on ShopGridCustomLinksPayload {
        links {
          id
          text
          url
        }
      }
    }
  }
`)

export const UPDATE_CUSTOM_LINK_COLORS = graphql(`
  mutation UpdateShopGridCustomLinkColors(
    $input: UpdateCustomLinksColorsInput!
  ) {
    updateCustomLinksColors(input: $input) {
      ... on EmptySuccess {
        _empty
      }
    }
  }
`)

export const UPDATE_CUSTOM_LINK = graphql(`
  mutation UpdateShopGridCustomLink($input: UpdateShopGridCustomLinkInput!) {
    updateShopGridCustomLink(input: $input) {
      ... on ShopGridCustomLinksPayload {
        color
        contrastColor
        links {
          id
          text
          url
        }
      }
    }
  }
`)

export const SWAP_CUSTOM_LINKS = graphql(`
  mutation SwapShopGridCustomLinks($input: SwapShopGridCustomLinksInput!) {
    swapShopGridCustomLinks(input: $input) {
      ... on ShopGridCustomLinksPayload {
        links {
          id
          text
          url
        }
      }
    }
  }
`)

export const UPDATE_POST_LINK = graphql(`
  mutation UpdateShopGridPostLink($input: UpdateShopGridPostLinkInput!) {
    updateShopGridPostLink(input: $input) {
      ... on EmptySuccess {
        _empty
      }
    }
  }
`)
